export default "__VITE_ASSET__CaWAODbS__"